// extracted by mini-css-extract-plugin
module.exports = {"table":"style__table__qfo97","thumbnail":"style__thumbnail__ki4zY"};